import { z } from "zod";

// isolatedDeclarations: define output shape as TS interface, annotate
// Zod const with z.ZodType<Interface> so tsc can emit declarations without
// reading across module boundaries (D-15 paranoid-strict tsconfig).

export interface Instruction {
  text: string;
}

// Minimal Phase 1 shape per D-08 + CONTEXT Deferred Ideas (AI2-02).
// Only `text` — no `note`, no `markdown`, no `timeOffsetMinutes`.
// AI2-02 (markdown) is deferred to v2; the strict object enforces that
// deferral: any attempt to add `markdown` at the schema level will require
// removing this strictObject and the test that asserts its rejection.
export const Instruction: z.ZodType<Instruction> = z.strictObject({
  text: z.string().min(1).max(2000),
});
